import {CardStatus} from "../constant/Const";

export const isBlockedCard = (status) => {
    return [CardStatus.userSuspend, CardStatus.adminSuspend, CardStatus.paymentOverdue].includes(status);
}
